/**
 * 隐私政策语言。
 *
 * 注意：隐私政策和用户协议是**两张独立的表**（这里和 getTermsOfServiceLang 各一份），可以不同步——
 * 某个语言先上隐私政策、后上用户协议是常态，改这里不会影响用户协议，反过来也一样。
 *
 * 取值顺序：浏览器语言 → 词条语言 Lang → 英文。
 * 表里的键同时接受「浏览器语言码」（如 ko）和「词条文件语言名」（全局 Lang，韩语是 korean、土耳其语是 turkish）；
 * 值是组件目录名（src/views/pm/user-agreement/privacy-policy/components/property-privacy-policy/<值>/）。
 */
export function getPrivacyPolicyLang() {
    const langs = Object.freeze({
        en: 'en',
        // 'zh-hant': 'zh-tw',
        // 'zh-tw': 'zh-tw',
        // 'zh-hk': 'zh-tw',
        'zh-CN': 'zh-cn',
        'zh-cn': 'zh-cn',
        ko: 'ko',
        korean: 'ko',
        tr: 'tr',
        turkish: 'tr',
        ja: 'ja',
        es: 'es',
        pl: 'pl',
        de: 'de',
        fr: 'fr',
        nl: 'nl',
        ro: 'ro',
        it: 'it'
        // ru: 'ru',
        // bs: 'bs',
        // da: 'da',
        // vi: 'vi',
        // pt: 'pt',
        // uk: 'uk',
        // he: 'he',
        // fa: 'fa',
        // az: 'az',
        // ar: 'ar',
        // cs: 'cs',
        // sv: 'sv',
        // th: 'th',
        // 'fr-FR': 'fr',
        // 'fr-CA': 'fr',
        // 'fr-CH': 'fr'
    });

    // 与 public/js/lang.js 的 formatCurrentLang 一致：去掉地区后缀，zh 例外（保留 zh-cn / zh-tw）
    const formatLang = (lang: string) => {
        const lowerCaseLang = String(lang || 'en').toLowerCase();
        const preLang = lowerCaseLang.split('-')[0];
        return preLang === 'zh' ? lowerCaseLang : preLang;
    };
    const hasLang = (key: string) => Object.prototype.hasOwnProperty.call(langs, key);

    // 先按浏览器语言取（词条没覆盖的语言，如罗马尼亚语，全局 Lang 会兜底成 en，也要能出对应语言的协议）
    const browserLang = formatLang(navigator.language);
    // 浏览器语言不在表里，再退回词条语言 Lang；都没有则兜底英文
    const targetLang = hasLang(browserLang) ? browserLang : formatLang(typeof Lang === 'undefined' ? 'en' : Lang);
    return hasLang(targetLang) ? langs[targetLang as keyof typeof langs] : 'en';
}

/**
 * 用户协议语言。
 *
 * 注意：和隐私政策各维护一份表（上面 getPrivacyPolicyLang 一份），两边可以不同步，互不影响。
 * 取值顺序、键的写法与上面一致：浏览器语言 → 词条语言 Lang → 英文。
 * 值是组件目录名（src/views/pm/user-agreement/terms-of-service/components/property-terms-of-service/<值>/）。
 */
export function getTermsOfServiceLang() {
    const langs = Object.freeze({
        en: 'en',
        // 'zh-hant': 'zh-tw',
        // 'zh-tw': 'zh-tw',
        // 'zh-hk': 'zh-tw',
        'zh-CN': 'zh-cn',
        'zh-cn': 'zh-cn',
        ko: 'ko',
        korean: 'ko',
        tr: 'tr',
        turkish: 'tr',
        ja: 'ja',
        es: 'es',
        pl: 'pl',
        de: 'de',
        fr: 'fr',
        nl: 'nl',
        ro: 'ro',
        it: 'it'
        // ru: 'ru',
        // bs: 'bs',
        // da: 'da',
        // vi: 'vi',
        // pt: 'pt',
        // uk: 'uk',
        // he: 'he',
        // fa: 'fa',
        // az: 'az',
        // ar: 'ar',
        // cs: 'cs',
        // sv: 'sv',
        // th: 'th',
        // 'fr-FR': 'fr',
        // 'fr-CA': 'fr',
        // 'fr-CH': 'fr'
    });

    // 与 public/js/lang.js 的 formatCurrentLang 一致：去掉地区后缀，zh 例外（保留 zh-cn / zh-tw）
    const formatLang = (lang: string) => {
        const lowerCaseLang = String(lang || 'en').toLowerCase();
        const preLang = lowerCaseLang.split('-')[0];
        return preLang === 'zh' ? lowerCaseLang : preLang;
    };
    const hasLang = (key: string) => Object.prototype.hasOwnProperty.call(langs, key);

    // 先按浏览器语言取（词条没覆盖的语言，如罗马尼亚语，全局 Lang 会兜底成 en，也要能出对应语言的协议）
    const browserLang = formatLang(navigator.language);
    // 浏览器语言不在表里，再退回词条语言 Lang；都没有则兜底英文
    const targetLang = hasLang(browserLang) ? browserLang : formatLang(typeof Lang === 'undefined' ? 'en' : Lang);
    return hasLang(targetLang) ? langs[targetLang as keyof typeof langs] : 'en';
}
